<template>
  <v-page-content class="mx-auto content-max-width">
    <div v-if="!editMode">
      <h5><router-link to="/news_feed">Лента новостей</router-link> /</h5>
      <h3>Новости</h3>
    </div>
    <div v-else>
      <h3 class="d-inline"><em class="far fa-1x fa-newspaper"></em> Новости</h3>
      <b-button
        variant="outline-primary"
        class="btn btn-default ml-3 mb-2"
        @click="addNews"
      >
        <em class="fas fa-plus mr-1"></em> Добавить новость
      </b-button>
      <content-types
        @filter="getFilteredData"
        :disable="!loadedBefore"
      ></content-types>
    </div>
    <div>
      <template v-if="allNews && allNews.length && (loadedBefore || page > 1)">
        <div class="row mb-3" v-for="news in allNews" :key="news.id">
          <div class="col-12 col-lg-3">
            <router-link :to="news.id.toString()" append>
              <b-img
                class="w-100"
                :src="
                  news.avatar
                    ? '/api/files/' +
                      news.files.find((p) => p.id === news.avatar)
                        .physicalName
                    : defaultImage
                "
                @error="$event.target.src = defaultImage"
                fluid
              />
            </router-link>
          </div>
          <div class="col-12 col-lg-9 newsContent">
            <div>
              <h4>
                {{ new Date(news.createdAt).toLocaleDateString() }}.
                <span
                  v-html="news.title ? news.title : 'Название отсутствует'"
                ></span>
              </h4>
            </div>
            <div
              v-html="news.shortDescription"
              v-show="news.shortDescription !== emptyText"
              class="text-justify"
            ></div>
            <br /><br />
            <div class="newsLink">
              <router-link :to="news.id.toString()" append
                >Перейти к новости</router-link
              >
            </div>
            <div class="news__statusBox" v-if="showStatus">
              <b-badge :variant="$_contentMixin_getBadge(news.status)">
                {{ news.status }}
              </b-badge>
            </div>
          </div>
        </div>
      </template>
      <b-alert
        v-else-if="loadedBefore"
        show
        variant="info"
        class="mx-auto"
        >Новости отсутствуют</b-alert
      >
      <template v-else>
        <skeleton-news :count="7" />
      </template>
    </div>
    <b-button
      variant="outline-primary"
      v-if="isMore"
      id="buttonShowMore"
      @click="showMore()"
      >Показать ещё новости</b-button
    >
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import contentMixin from '@/components/helpers/mixins/content-mixin'
import { emptyShortDescription } from '@/config/config'
import { statusFilters } from '@/config/content/statuses'
import { typeTranslates } from '@/config/content/types'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'

const ContentTypes = () => import('@/components/content/edit/ListGroupButtonContentTypes.vue')

export default {
  name: 'AllNews',
  components: {
    SkeletonNews,
    ContentTypes
  },
  props: {
    editMode: Boolean
  },
  mixins: [contentMixin],
  data() {
    return {
      countOnPage: 8,
      page: 1,
      isMore: false,
      emptyText: emptyShortDescription,
      defaultImage: '/images/w1400_1.jpg',
      filters: [
        {
          param: 'status',
          needle: [statusFilters.accepted]
        }
      ],
      loadedBefore: false
    }
  },
  beforeDestroy() {
    this.setNews([])
  },
  mounted() {
    if (!this.editMode) {
      this.fetchNews({
        perPage: this.countOnPage,
        pageNumber: this.page,
        filters: this.filters
      }).then((total) => {
        this.loadedBefore = true
        if (total > this.page * this.countOnPage) {
          this.isMore = true
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      allNews: 'content/getNews'
    }),
    showStatus() {
      return this.$route.path.includes('content')
    }
  },
  methods: {
    ...mapActions({
      fetchNews: 'content/fetchNews',
      addContent: 'content/addContent'
    }),
    ...mapMutations({
      setNews: 'content/setNews'
    }),
    addNews() {
      // добавляем контент, после - редирект на только что созданную новость
      this.addContent(typeTranslates.news).then((res) => {
        this.$router.push(`/content/news/${res.contentObject.id}`)
      })
    },
    getFilteredData(type) {
      this.isMore = false
      this.loadedBefore = false
      if (type === 'все') {
        this.filters[0].needle = [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.draft
        ]
      } else {
        this.filters[0].needle = [type]
      }
      this.page = 1
      this.fetchNews({
        perPage: this.countOnPage,
        pageNumber: this.page,
        filters: this.filters
      }).then((total) => {
        this.loadedBefore = true
        if (total > this.page * this.countOnPage) {
          this.isMore = true
        }
      })
    },
    showMore() {
      this.page += 1
      this.loadedBefore = false
      this.fetchNews({
        perPage: this.countOnPage,
        pageNumber: this.page,
        filters: this.filters
      }).then((total) => {
        this.loadedBefore = true
        if (total < this.page * this.countOnPage) {
          this.isMore = false
        }
      })
    }
  }
}
</script>

<style scoped>
#buttonShowMore {
  width: 100%;
}

.newsLink {
  bottom: 0px;
  position: absolute;
}

.news__statusBox {
  float: right;
}
</style>
